import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"
import { Modal } from "tailwindcss-stimulus-components"
import Cookie from 'js-cookie'

export default class extends Controller {
  static targets = ["wrapper", "body", "container", 'permanentlyDismissCheckbox']
  static values = {
    dismissible: 'true',
    cookie: String,
  }

  connect() {
    enter(this.containerTarget)
    enter(this.wrapperTarget)
    enter(this.bodyTarget)

    //document.addEventListener('turbo:submit-end', this.handleSubmit)
    this.element.addEventListener('turbo:submit-end', this.handleSubmit)

  }

  disconnect() {
    //document.removeEventListener('turbo:submit-end', this.handleSubmit)
    this.element.removeEventListener('turbo:submit-end', this.handleSubmit)
  }

  close() {
    if (event.detail.success === false) return

    if (this.dismissibleValue == 'true') {
      if (this.hasPermanentlyDismissCheckboxTarget && this.permanentlyDismissCheckboxTarget.checked) {
        Cookie.set(this.cookieValue, true, { expires: 365, path: '/' })
      }

      leave(this.wrapperTarget)
      leave(this.containerTarget)

      leave(this.bodyTarget).then(() => {
        this.element.remove()
      })

      this.element.closest("turbo-frame").src = undefined
    }
  }

  handleKeyup(e) {
    if (this.dismissibleValue == 'true') {
      if (e.code == "Escape") {
        this.close()
      }
    }
  }

  handleSubmit = (e) => {
    if (e.detail.success) {
      this.close()
    }
  }
}
